import { COLORS } from '../IndividualPlan/tokens';
import { BENCH } from '../Benchmarks/tokens';
import { REPORT } from '../ProgressReport/tokens';
import { ROSTER } from '../Roster/tokens';

export const GROWTH = {
  ink: COLORS.ink,
  muted: COLORS.muted,
  disabled: '#7F7F99',
  surface: COLORS.bg,
  cardBg: '#FFFFFF',
  divider: COLORS.divider,
  action: COLORS.navy,
  actionLight: '#8181D9',
  actionSoft: '#EFEFFA',
  actionSofter: '#D4D4F2',
  hot: BENCH.hot,
  font: BENCH.font,
  bands: ['#F86464', '#FBDA67', '#2BCC57', '#0094FF', '#7270FE'],
  change: { up: '#317123', down: '#B20101' },
  move: { up: '#F1FAEF', same: '#E3E3E8', down: '#FFE5E5' },
  moveBorder: { up: '#BBE7B1', same: '#C1C1CD', down: '#FFBDBD' },
  track: '#E3E3E8',
  hatch: REPORT.hatchSwatch,
  pending: '#F6F6F8',
  status: {
    Reviewed: { bg: '#F1FAEF', fg: '#1C4214' },
    Submitted: { bg: '#E8F4FD', fg: '#0B3D7F' },
    'Not started': { bg: '#E3E3E8', fg: '#2C2C52' },
    Unscorable: { bg: '#FDEAD8', fg: '#843501' },
  } as Record<string, { bg: string; fg: string }>,
  open: { bg: '#FDEAD8', fg: '#843501' },
  tag: { LTEL: ROSTER.chip.ltel, Newcomer: ROSTER.chip.newcomer } as Record<string, { bg: string; fg: string }>,
} as const;
